import React, { useState, useRef, useEffect } from 'react'
import { ButtonGroup, Button, Divider, Grid, FormControl, Select, InputLabel, MenuItem, ListItemText } from '@material-ui/core'
import axios from 'axios'

// styles
import useStyles from './styles'

// components
import WorkforceReport from './components/Workforce'
import CashCompensation from './components/CashCompensation/CashCompensation'
import Organization from './components/Organization/'
import { isEmpty, forEach, find, cloneDeep, orderBy } from 'lodash'
import { useMasterState } from '../../context/MasterContext'

const filter = {
	'dataFilters': {
		'department': [],
		'country': [],
		'function': [],
		'manager': [],
		'costCenter': [],
	},
}

const filtersInitalValue = {
	'CurrentAverageCostOfLaborDetail': cloneDeep(filter),
	'CurrentAverageCostOfLaborSummary': cloneDeep(filter),
	'ProjectedAverageCostOfLaborDetail': cloneDeep(filter),
	'ProjectedAverageCostOfLaborSummary': cloneDeep(filter),
	'PerformanceRatingOrgDetail': cloneDeep(filter),
	'PerformanceRatingOrgSummary': cloneDeep(filter),
	'PerformanceRatingAndCompaRatioDetail': cloneDeep(filter),
	'PerformanceRatingAndCompaRatioSummary': cloneDeep(filter),
	'OrganisationCompensation': cloneDeep(filter),
	'DepartmentalCompensation': cloneDeep(filter),
	'WorkforceCurrentHeadCountDetails': cloneDeep(filter),
	'WorkforceCurrentHeadCountSummary': cloneDeep(filter),
	'WorkforceProjectedHeadCountDetails': cloneDeep(filter),
}

const createFilterPayload = (filterPayload) => {
	const newPayload = {}
	forEach(filterPayload.dataFilters, (valueArr, key) => {
		newPayload[key] = valueArr.filter(v => v)
	})
	return { dataFilters: newPayload }
}

export default function Reports(props) {
	const { masterData } = useMasterState()
	const classes = useStyles()

	const [reportType, setReportType] = useState('workforce')
	const [forecastsDataVersion, setForecastsDataVersion] = useState(1)
	const [forecastOptions, setForecastOptions] = useState([])
	const [selectedForecasts, setSelectedForecasts] = useState({
		workforceProjectedDetails: null,
		organizationProjectedDetails: null,
		organizationProjectedSummary: null,
	})


	const [reportFilters, setReportFilters] = useState(filtersInitalValue)

	const reportsData = {
		'CurrentAverageCostOfLaborDetail': [],
		'CurrentAverageCostOfLaborSummary': [],
		'ProjectedAverageCostOfLaborDetail': [],
		'ProjectedAverageCostOfLaborSummary': [],
		'PerformanceRatingOrgDetail': [],
		'PerformanceRatingOrgSummary': [],
		'PerformanceRatingAndCompaRatioDetail': [],
		'PerformanceRatingAndCompaRatioSummary': [],
		'WorkforceCurrentHeadCountDetails': [],
		'WorkforceCurrentHeadCountSummary': [],
		'WorkforceProjectedHeadCountDetails': [],
		'OrganisationCompensation': [],
		'DepartmentalCompensation': [],
	}

	const reportFilterType = {
		'CurrentAverageCostOfLaborDetail': 'Select by country',
		'CurrentAverageCostOfLaborSummary': 'Select by country',
		'ProjectedAverageCostOfLaborDetail': 'Select by country',
		'ProjectedAverageCostOfLaborSummary': 'Select by country',
		'PerformanceRatingOrgDetail': 'Select by country',
		'PerformanceRatingOrgSummary': 'Select by country',
		'PerformanceRatingAndCompaRatioDetail': 'Select by country',
		'PerformanceRatingAndCompaRatioSummary': 'Select by country',
		'WorkforceCurrentHeadCountDetails': 'Select by country',
		'WorkforceCurrentHeadCountSummary': 'Select by country',
		'WorkforceProjectedHeadCountDetails': 'Select by country',
		'OrganisationCompensation': 'Select by country',
		'DepartmentalCompensation': 'Select by country',
	}

	const reportFetchedFilterData = {
		'CurrentAverageCostOfLaborDetail': [],
		'CurrentAverageCostOfLaborSummary': [],
		'ProjectedAverageCostOfLaborDetail': [],
		'ProjectedAverageCostOfLaborSummary': [],
		'PerformanceRatingOrgDetail': [],
		'PerformanceRatingOrgSummary': [],
		'PerformanceRatingAndCompaRatioDetail': [],
		'PerformanceRatingAndCompaRatioSummary': [],
		'WorkforceCurrentHeadCountDetails': [],
		'WorkforceCurrentHeadCountSummary': [],
		'WorkforceProjectedHeadCountDetails': [],
		'OrganisationCompensation': [],
		'DepartmentalCompensation': [],
	}

	const filtersDataOrignalObject = {}

	Object.keys(reportsData).map(key => {
		filtersDataOrignalObject[key] = {
			countriesList: [],
			departmentsList: [],
			jobFunctionsList: [],
			costCentersList: [],
		}
		return null
	})

	const [fetchedFilterData, setFetchedFilterData] = useState(reportFetchedFilterData)
	const [filtersData, setFiltersData] = useState(filtersDataOrignalObject)
	const [reportData, setReportData] = useState(reportsData)
	const [reportDataVersion, setReportDataVersion] = useState(0)
	const [selectedCurrency, setSelectedCurrency] = useState(null)
	const [availableCurrencies, setAvailableCurrencies] = useState([])
	const [availableColumns, setAvailableColumns] = useState(null)
	const [componentName, setComponentName] = useState('')
	const [reportFilterVersion, setReportFilterVersion] = useState(0)
	const [departmentReportVersion, setDepartmentReportVersion] = useState(0)
	const [showOnlyWorkForce, setShowOnlyWorkForce] = useState(false)
	const [reportFiltersType, setReportFiltersType] = useState(reportFilterType)
	const firstDataFetch = useRef((isEmpty(JSON.parse(localStorage.getItem('reportData')))))

	useEffect(() => {
		let user = JSON.parse(localStorage.getItem('user'))
		if (user.roles.includes('finance') || user.roles.includes('client_group')) {
			setShowOnlyWorkForce(true)
		}
	}, [])

	useEffect(() => {
		fetchCurrencies()
		fetchCountryDepartments()
		setCurrentOpenTab()
	}, [])

	const fetchCountryDepartments = async (componentName = '', filterType = 'country') => {
		try {
			if (componentName === '') {
				Promise.all([
					axios.get('/api/company/get_company_countries_with_departments?group_by=department'),
					axios.get('/api/company/get_company_countries_with_departments?group_by=country'),
					axios.get('/api/company/get_company_countries_with_departments?group_by=country&workforce_filters=true')
				]).then(responses => {
					let newFetchedFilterData = { ...fetchedFilterData }
					let newFilterTypes = localStorage.getItem('filtersType') !== null ? JSON.parse(localStorage.getItem('filtersType')) : { ...reportFiltersType }
					Object.keys(newFetchedFilterData).forEach(report => {
						if (newFilterTypes[report] === 'Select by country') {
							if(report === 'ProjectedAverageCostOfLaborDetail' || report === 'ProjectedAverageCostOfLaborSummary' || report === 'WorkforceProjectedHeadCountDetails') {
								newFetchedFilterData[report] = responses[2].data.data
							} else {
								newFetchedFilterData[report] = responses[1].data.data
							}
							newFetchedFilterData[report].forEach(data => {
								let costCentersArray = data.cost_centers.filter(cost_center => {
									if (cost_center === null) {
										return false
									} else {
										return true
									}
								})
								data.cost_centers = costCentersArray
							})
						} else {
							newFetchedFilterData[report] = responses[0].data.data
						}
					})
					setFetchedFilterData(newFetchedFilterData)
				})
			} else {
				setComponentName(componentName)
				let params = '?group_by=' + filterType
				let response = await axios.get('/api/company/get_company_countries_with_departments' + params)
				if (filterType === 'country') {
					response.data.data.forEach(data => {
						let costCentersArray = data.cost_centers.filter(cost_center => {
							if (cost_center === null) {
								return false
							} else {
								return true
							}
						})
						data.cost_centers = costCentersArray
					})
				}
				setFetchedFilterData({ ...fetchedFilterData, [componentName]: response.data.data })
			}
		} catch (e) {
			console.log(e)
		}
	}

	useEffect(() => {
		setFiltersFromLocalStorage()
	}, [fetchedFilterData])

	const setCurrentOpenTab = () => {
		if (localStorage.getItem('active_report_type') !== null) {
			let currentOpenTab = localStorage.getItem('active_report_type')
			setReportType(currentOpenTab)
		}
	}

	const fetchCurrencies = async () => {
		try {
			const result = await axios.get('/api/company/get_company_currency_with_dollar_rate')
			if (result.status) {
				setAvailableCurrencies(result.data.data)
			} else {
				setAvailableCurrencies([])
			}
		} catch (e) {
			console.log(e)
			setAvailableCurrencies([])
		}
	}

	const onApply = (componentName) => {
		setComponentName(componentName)
		props.onReportDataChanged(componentName)

		if (componentName !== 'DepartmentalCompensation') {
			setReportFilterVersion(reportFilterVersion + 1)
		} else {
			// setReportFilterVersion(reportFilterVersion + 1)
			setDepartmentReportVersion(departmentReportVersion + 1)
		}
	}

	const resetFilter = (componentName) => {
		setComponentName(componentName)
		setReportFilters({ ...reportFilters, [componentName]: filter })
		selectAllFilters(componentName)
		props.onReportDataChanged(componentName)
		if (componentName === 'DepartmentalCompensation') {
			setDepartmentReportVersion(departmentReportVersion + 1)
		} else {
			setReportFilterVersion(reportFilterVersion + 1)
		}
	}

	const fetchMasterData = async (componentName = '') => {
		try {
			const result = await axios.post(`/api/report`, componentName !== '' ? createFilterPayload(reportFilters[componentName]) : filter)
			let componentReportData = {}
			let newReportData = reportsData
			if (componentName !== '') {
				componentReportData = result.data.data
				setReportData({ ...reportData, [componentName]: componentReportData })
				setReportDataVersion(reportDataVersion + 1)
			} else {
				for (let element in newReportData) {
					newReportData[element] = result.data.data
				}
				setReportData(newReportData)
				firstDataFetch.current = true
			}
		} catch (e) {
			console.log(e)
			setReportData([])
		}
	}

	useEffect(() => {
		if (firstDataFetch.current) {
			localStorage.setItem('reportData', JSON.stringify(reportData))
		}
	}, [reportDataVersion, reportData])

	useEffect(() => {
		if (localStorage.getItem('filtersType') !== null) {
			let localFiltersType = JSON.parse(localStorage.getItem('filtersType'))
			setReportFiltersType(localFiltersType)
		}
		if (localStorage.getItem('reportFilters') !== null) {
			let localReportFilters = JSON.parse(localStorage.getItem('reportFilters'))
			setReportFilters(localReportFilters)
		}
		if (localStorage.getItem('selectedCurrency') !== null) {
			let localSelectedCurrency = JSON.parse(localStorage.getItem('selectedCurrency'))
			setSelectedCurrency(localSelectedCurrency)
		}
	}, [])

	useEffect(() => {
		let localReportData = JSON.parse(localStorage.getItem('reportData'))
		if (!isEmpty(localReportData)) {
			setReportData(localReportData);
		} else {
			fetchMasterData()
		}
	}, [])

	const setFiltersFromLocalStorage = () => {
		if (componentName !== '') {
			selectAllFilters(componentName)
		} else if (localStorage.getItem('filtersData') !== null) {
			let localFiltersData = JSON.parse(localStorage.getItem('filtersData'))
			let localReportFilters = JSON.parse(localStorage.getItem('reportFilters'))
			Object.keys(localFiltersData).forEach(filter => {
				if (localReportFilters !== null) {
					if (reportFiltersType[filter] === 'Select by country') {

						localReportFilters[filter]['dataFilters']['country'].forEach(country => {

							localFiltersData[filter].departmentsList = []
							localFiltersData[filter].jobFunctionsList = []
							localFiltersData[filter].costCentersList = []

							fetchedFilterData[filter].forEach(filterData => {
								if (filterData.country === country) {
									localFiltersData[filter].departmentsList = localFiltersData[filter].departmentsList.concat(
										filterData.departments.filter((object, index) => {
											if (find(localFiltersData[filter].departmentsList, { 'department': object }) === undefined) {
												return true
											} else {
												return false
											}
										}).map(object => {
											return { 'department': object }
										})
									)
									localFiltersData[filter].jobFunctionsList = localFiltersData[filter].jobFunctionsList.concat(
										filterData.company_job_functions.filter(object => {
											if (!localFiltersData[filter].jobFunctionsList.includes(object)) {
												return true
											} else {
												return false
											}
										})
									)
									localFiltersData[filter].costCentersList = localFiltersData[filter].costCentersList.concat(
										filterData.cost_centers.filter(object => {
											if (!localFiltersData[filter].costCentersList.includes(object)) {
												return true
											} else {
												return false
											}
										})
									)
								}
							})
						})
					} else {
						localFiltersData[filter].countriesList = []
						localFiltersData[filter].jobFunctionsList = []
						localFiltersData[filter].costCentersList = []

						localReportFilters[filter]['dataFilters']['department'].forEach(department => {
							fetchedFilterData[filter].forEach(filterData => {
								if (filterData.departments === department) {
									localFiltersData[filter].countriesList = localFiltersData[filter].countriesList.concat(
										filterData.country.filter((object, index) => {
											if (find(localFiltersData[filter].countriesList, { 'country': object }) === undefined) {
												return true
											} else {
												return false
											}
										}).map(object => {
											return { 'country': object }
										})
									)
									localFiltersData[filter].jobFunctionsList = localFiltersData[filter].jobFunctionsList.concat(
										filterData.company_job_functions.filter(object => {
											if (!localFiltersData[filter].jobFunctionsList.includes(object)) {
												return true
											} else {
												return false
											}
										})
									)
									localFiltersData[filter].costCentersList = localFiltersData[filter].costCentersList.concat(
										filterData.cost_centers.filter(object => {
											if (!localFiltersData[filter].costCentersList.includes(object) && object !== null) {
												return true
											} else {
												return false
											}
										})
									)
								}
							})
						})
					}
				}
				localFiltersData[filter].countriesList = orderBy(localFiltersData[filter].countriesList, [country => country.country.toLowerCase()], ['asc'])
				localFiltersData[filter].departmentsList = orderBy(localFiltersData[filter].departmentsList, [department => department.department.toLowerCase()], ['asc'])
				localFiltersData[filter].costCentersList.sort(function (a, b) {
					return a.toLowerCase().localeCompare(b.toLowerCase());
				});
				localFiltersData[filter].jobFunctionsList.filter(jobFunction => jobFunction!= null).sort(function (a, b) {
					return a.toLowerCase().localeCompare(b.toLowerCase());
				});
			})
			setFiltersData(localFiltersData)
		} else {
			selectAllFilters()
		}
	}

	const selectAllFilters = (componentName = '') => {
		let newFiltersData = {}
		if (componentName !== '') {
			newFiltersData[componentName] = {
				countriesList: [],
				departmentsList: [],
				jobFunctionsList: [],
				costCentersList: [],
			}
			fetchedFilterData[componentName].forEach(fetchedFilter => {
				if (reportFiltersType[componentName] === 'Select by country') {
					newFiltersData[componentName].countriesList.push({ country: fetchedFilter.country })
					newFiltersData[componentName]['departmentsList'] = newFiltersData[componentName].departmentsList.concat(
						fetchedFilter.departments.filter((departmentStr, index) => {
							if (find(newFiltersData[componentName]['departmentsList'], { 'department': departmentStr }) === undefined) {
								return true
							} else {
								return false
							}
						}).map(departmentStr => {
							return { 'department': departmentStr }
						})
					)
					newFiltersData[componentName]['jobFunctionsList'] = newFiltersData[componentName].jobFunctionsList.concat(
						fetchedFilter.company_job_functions.filter(object => {
							if (!newFiltersData[componentName]['jobFunctionsList'].includes(object)) {
								return true
							} else {
								return false
							}
						})
					)
					newFiltersData[componentName]['costCentersList'] = newFiltersData[componentName].costCentersList.concat(
						fetchedFilter.cost_centers.filter(object => {
							if (!newFiltersData[componentName]['costCentersList'].includes(object)) {
								return true
							} else {
								return false
							}
						})
					)
				} else {
					newFiltersData[componentName].departmentsList.push({ department: fetchedFilter.departments })
					newFiltersData[componentName]['countriesList'] = newFiltersData[componentName].countriesList.concat(
						fetchedFilter.country.filter((country, index) => {
							if (find(newFiltersData[componentName]['countriesList'], { 'country': country }) === undefined) {
								return true
							} else {
								return false
							}
						}).map(country => {
							return { 'country': country }
						})
					)
					newFiltersData[componentName]['jobFunctionsList'] = newFiltersData[componentName].jobFunctionsList.concat(
						fetchedFilter.company_job_functions.filter(object => {
							if (!newFiltersData[componentName]['jobFunctionsList'].includes(object)) {
								return true
							} else {
								return false
							}
						})
					)
					newFiltersData[componentName]['costCentersList'] = newFiltersData[componentName].costCentersList.concat(
						fetchedFilter.cost_centers.filter(object => {
							if (!newFiltersData[componentName]['costCentersList'].includes(object) && object !== null) {
								return true
							} else {
								return false
							}
						})
					)
				}
			})

			newFiltersData[componentName].countriesList = orderBy(newFiltersData[componentName].countriesList, [country => country.country.toLowerCase()], ['asc'])
			newFiltersData[componentName].departmentsList = orderBy(newFiltersData[componentName].departmentsList, [department => department.department.toLowerCase()], ['asc'])
			newFiltersData[componentName].costCentersList.sort(function (a, b) {
				return a.toLowerCase().localeCompare(b.toLowerCase());
			});
			newFiltersData[componentName].jobFunctionsList.filter(jobFunction => jobFunction != null).sort(function (a, b) {
				return a.toLowerCase().localeCompare(b.toLowerCase());
			});

			setFiltersData({ ...filtersData, [componentName]: newFiltersData[componentName] })
			let newReportFilters = { ...reportFilters[componentName] }
			newReportFilters['dataFilters'].country = [...newFiltersData[componentName].countriesList].map(obj => {
				return obj.country
			})
			newReportFilters['dataFilters'].department = [...newFiltersData[componentName].departmentsList].map(obj => {
				return obj.department
			})
			newReportFilters['dataFilters'].function = [...newFiltersData[componentName].jobFunctionsList]
			newReportFilters['dataFilters'].costCenter = [...newFiltersData[componentName].costCentersList]
			setReportFilters({ ...reportFilters, [componentName]: newReportFilters })
		} else {
			forEach(Object.keys(filtersData), newFilterKey => {
				newFiltersData[newFilterKey] = {
					countriesList: [],
					departmentsList: [],
					jobFunctionsList: [],
					costCentersList: [],
				}
			})
			forEach(Object.keys(filtersData), newFilterKey => {
				fetchedFilterData[newFilterKey].forEach(fetchedFilter => {
					if (reportFiltersType[newFilterKey] === 'Select by country') {
						newFiltersData[newFilterKey].countriesList.push({ country: fetchedFilter.country })
						newFiltersData[newFilterKey]['departmentsList'] = newFiltersData[newFilterKey].departmentsList.concat(
							fetchedFilter.departments.filter((departmentStr, index) => {
								if (find(newFiltersData[newFilterKey]['departmentsList'], { 'department': departmentStr }) === undefined) {
									return true
								} else {
									return false
								}
							}).map(departmentStr => {
								return { 'department': departmentStr }
							})
						)
						newFiltersData[newFilterKey]['jobFunctionsList'] = newFiltersData[newFilterKey].jobFunctionsList.concat(
							fetchedFilter.company_job_functions.filter(object => {
								if (!newFiltersData[newFilterKey]['jobFunctionsList'].includes(object)) {
									return true
								} else {
									return false
								}
							})
						)
						newFiltersData[newFilterKey]['costCentersList'] = newFiltersData[newFilterKey].costCentersList.concat(
							fetchedFilter.cost_centers.filter(object => {
								if (!newFiltersData[newFilterKey]['costCentersList'].includes(object)) {
									return true
								} else {
									return false
								}
							})
						)
					} else {
						newFiltersData[newFilterKey].departmentsList.push({ department: fetchedFilter.departments })
						newFiltersData[newFilterKey]['countriesList'] = newFiltersData[newFilterKey].countriesList.concat(
							fetchedFilter.country.filter((country, index) => {
								if (find(newFiltersData[newFilterKey]['countriesList'], { 'country': country }) === undefined) {
									return true
								} else {
									return false
								}
							}).map(country => {
								return { 'country': country }
							})
						)
						newFiltersData[newFilterKey]['jobFunctionsList'] = newFiltersData[newFilterKey].jobFunctionsList.concat(
							fetchedFilter.company_job_functions.filter(object => {
								if (!newFiltersData[newFilterKey]['jobFunctionsList'].includes(object)) {
									return true
								} else {
									return false
								}
							})
						)
					}
				})
				newFiltersData[newFilterKey].countriesList = orderBy(newFiltersData[newFilterKey].countriesList, [country => country.country.toLowerCase()], ['asc'])
				newFiltersData[newFilterKey].departmentsList = orderBy(newFiltersData[newFilterKey].departmentsList, [department => department.department.toLowerCase()], ['asc'])
				newFiltersData[newFilterKey].costCentersList.sort(function (a, b) {
					return a.toLowerCase().localeCompare(b.toLowerCase());
				});
				newFiltersData[newFilterKey].jobFunctionsList.filter(jobFunction => jobFunction != null).sort(function (a, b) {
					return a.toLowerCase().localeCompare(b.toLowerCase());
				});
			})
			setFiltersData(newFiltersData)
			let newReportFilters = { ...reportFilters }
			Object.keys(reportFilters).forEach(filterKey => {
				newReportFilters[filterKey]['dataFilters'].country = [...newFiltersData[filterKey].countriesList].map(obj => {
					return obj.country
				})
				newReportFilters[filterKey]['dataFilters'].department = [...newFiltersData[filterKey].departmentsList].map(obj => {
					return obj.department
				})
				newReportFilters[filterKey]['dataFilters'].function = [...newFiltersData[filterKey].jobFunctionsList]
				newReportFilters[filterKey]['dataFilters'].costCenter = [...newFiltersData[filterKey].costCentersList]
			})
			setReportFilters(newReportFilters)
		}
	}

	useEffect(() => {
		if (firstDataFetch.current) {
			localStorage.setItem('reportFilters', JSON.stringify(reportFilters))
			localStorage.setItem('filtersData', JSON.stringify(filtersData))
			localStorage.setItem('filtersType', JSON.stringify(reportFiltersType))
			fetchReportData(componentName)
		} else {
			let localReportData = JSON.parse(localStorage.getItem('reportData'))
			if (!isEmpty(localReportData)) {
				setReportData(localReportData)
				firstDataFetch.current = true
			} else {
				fetchReportData()
			}
		}
	}, [reportFilterVersion, departmentReportVersion])

	const fetchReportData = async (componentName = '') => {
		try {
			const result = await axios.post(`/api/report`, componentName !== '' ? createFilterPayload(reportFilters[componentName]) : filter)
			let componentReportData = {}
			let newReportData = reportsData
			if (componentName !== '') {
				componentReportData = result.data.data
				setReportData({ ...reportData, [componentName]: componentReportData })
				setReportDataVersion(reportDataVersion + 1)
			} else {
				for (let element in newReportData) {
					newReportData[element] = result.data.data
				}
				setReportData(newReportData)
				firstDataFetch.current = true
			}
		} catch (e) {
			console.log(e)
			setReportData([])
		}
	}

	useEffect(() => {
		Promise.all([
			axios('/api/employee/findFilledDateInEmployees')
		]).then(function (responses) {
			setAvailableColumns(responses[0].data.data)
		})
	}, [])

	const changeReport = reportName => {
		setReportType(reportName)
		localStorage.setItem('active_report_type', reportName)
	}

	const selectAllCountries = (filterName, componentName, value) => {
		if (reportFiltersType[componentName] !== 'Select by country') {
			let componentFilters = { ...reportFilters[componentName], 'dataFilters': { ...reportFilters[componentName]['dataFilters'], [filterName]: value } }
			componentFilters['dataFilters'].country = value.map(obj => {
				return obj.country
			})
			setReportFilters({ ...reportFilters, [componentName]: componentFilters })
		} else {
			let countries = value.filter(country => {
				if (country !== undefined) {
					return true
				} else {
					return false
				}
			}).map(object => {
				return object.country
			})
			dataFilterSelectByCountry(filterName, componentName, countries)
		}
	}

	const selectAllDepartments = (filterName, componentName, value) => {
		if (reportFiltersType[componentName] !== 'Select by department') {
			let componentFilters = { ...reportFilters[componentName], 'dataFilters': { ...reportFilters[componentName]['dataFilters'], [filterName]: value } }
			componentFilters['dataFilters'].department = value.map(obj => {
				return obj.department
			})
			setReportFilters({ ...reportFilters, [componentName]: componentFilters })
		} else {
			let departments = value.map(object => {
				return object.department
			})
			dataFilterSelectByDepartment(filterName, componentName, departments)
		}
	}

	const selectAllJobFunctions = (filterName, componentName, value) => {
		let componentFilters = { ...reportFilters[componentName], 'dataFilters': { ...reportFilters[componentName]['dataFilters'], [filterName]: value } }
		componentFilters['dataFilters'].function = value
		setReportFilters({ ...reportFilters, [componentName]: componentFilters })
	}

	const selectAllCostCenters = (filterName, componentName, value) => {
		let componentFilters = { ...reportFilters[componentName], 'dataFilters': { ...reportFilters[componentName]['dataFilters'], [filterName]: value } }
		componentFilters['dataFilters'].costCenter = value
		setReportFilters({ ...reportFilters, [componentName]: componentFilters })
	}

	const onDataFilterSelect = (filterName, componentName, value) => {
		if (filterName === 'country' && reportFiltersType[componentName] === 'Select by country') {
			dataFilterSelectByCountry(filterName, componentName, value)
		}
		else if (filterName === 'department' && reportFiltersType[componentName] === 'Select by department') {
			dataFilterSelectByDepartment(filterName, componentName, value)
		}
		else if (filterName === 'filterType') {
			setReportFiltersType({ ...reportFiltersType, [componentName]: value })
			fetchCountryDepartments(componentName, value === 'Select by country' ? 'country' : 'department')
		}
		else if (filterName === 'countries') {
			selectAllCountries(filterName, componentName, value)
		}
		else if (filterName === 'departments') {
			selectAllDepartments(filterName, componentName, value)
		}
		else if (filterName === 'functions') {
			selectAllJobFunctions(filterName, componentName, value)
		}
		else if (filterName === 'costcenters') {
			selectAllCostCenters(filterName, componentName, value)
		}
		else {
			let componentFilters = { ...reportFilters[componentName], 'dataFilters': { ...reportFilters[componentName]['dataFilters'], [filterName]: value } }
			setReportFilters({ ...reportFilters, [componentName]: componentFilters })
		}
	}

	const dataFilterSelectByDepartment = (filterName, componentName, value) => {
		let componentFilters = { ...reportFilters[componentName], 'dataFilters': { ...reportFilters[componentName]['dataFilters'], [filterName]: value } }
		if (value.length !== 0) {
			let componentFiltersData = { ...filtersData[componentName] }

			componentFiltersData.countriesList = []
			componentFiltersData.jobFunctionsList = []
			componentFiltersData.costCentersList = []

			value.forEach(department => {
				fetchedFilterData[componentName].forEach(object => {
					if (object.departments === department) {
						object.country.forEach(country => {
							if (find(componentFiltersData.countriesList, { 'country': country }) === undefined) {
								componentFiltersData.countriesList.push({ 'country': country })
							}
						})
						componentFiltersData.jobFunctionsList = componentFiltersData.jobFunctionsList.concat(
							object.company_job_functions.filter(object => {
								if (!componentFiltersData.jobFunctionsList.includes(object)) {
									return true
								} else {
									return false
								}
							})
						)
						componentFiltersData.costCentersList = componentFiltersData.costCentersList.concat(
							object.cost_centers.filter(object => {
								if (!componentFiltersData.costCentersList.includes(object) && object !== null) {
									return true
								} else {
									return false
								}
							})
						)
					}
				})
			})

			componentFiltersData.countriesList = orderBy(componentFiltersData.countriesList, [country => country.country.toLowerCase()], ['asc'])
			componentFiltersData.departmentsList = orderBy(componentFiltersData.departmentsList, [department => department.department.toLowerCase()], ['asc'])
			componentFiltersData.costCentersList.sort(function (a, b) {
				return a.toLowerCase().localeCompare(b.toLowerCase());
			});
			componentFiltersData.jobFunctionsList.filter(jobFunction => jobFunction != null).sort(function (a, b) {
				return a.toLowerCase().localeCompare(b.toLowerCase());
			});

			setFiltersData({ ...filtersData, [componentName]: componentFiltersData })

			componentFilters['dataFilters'].country = componentFiltersData.countriesList.map(obj => {
				return obj.country
			})
			componentFilters['dataFilters'].department = value
			componentFilters['dataFilters'].function = componentFiltersData.jobFunctionsList
			componentFilters['dataFilters'].costCenter = componentFiltersData.costCentersList
		} else {
			let componentFiltersData = { ...filtersData[componentName] }

			componentFiltersData.countriesList = []
			componentFiltersData.jobFunctionsList = []
			componentFiltersData.costCentersList = []

			setFiltersData({ ...filtersData, [componentName]: componentFiltersData })

			componentFilters = filter
		}
		setReportFilters({ ...reportFilters, [componentName]: componentFilters })
	}

	const dataFilterSelectByCountry = (filterName, componentName, value) => {
		let componentFilters = { ...reportFilters[componentName], 'dataFilters': { ...reportFilters[componentName]['dataFilters'], [filterName]: value } }
		if (value.length !== 0) {
			let componentFiltersData = { ...filtersData[componentName] }

			componentFiltersData.departmentsList = []
			componentFiltersData.jobFunctionsList = []
			componentFiltersData.costCentersList = []

			fetchedFilterData[componentName].forEach((object, key) => {
				value.forEach((country, index) => {
					if (object.country === country) {
						componentFiltersData.departmentsList = componentFiltersData.departmentsList.concat(
							object.departments.filter((object, index) => {
								if (find(componentFiltersData.departmentsList, { 'department': object }) === undefined) {
									return true
								} else {
									return false
								}
							}).map(object => {
								return { 'department': object }
							})
						)
						componentFiltersData.jobFunctionsList = componentFiltersData.jobFunctionsList.concat(
							object.company_job_functions.filter(object => {
								if (!componentFiltersData.jobFunctionsList.includes(object)) {
									return true
								} else {
									return false
								}
							})
						)
						componentFiltersData.costCentersList = componentFiltersData.costCentersList.concat(
							object.cost_centers.filter(object => {
								if (!componentFiltersData.costCentersList.includes(object)) {
									return true
								} else {
									return false
								}
							})
						)
					}
				})
			})

			componentFiltersData.countriesList = orderBy(componentFiltersData.countriesList, [country => country.country.toLowerCase()], ['asc'])
			componentFiltersData.departmentsList = orderBy(componentFiltersData.departmentsList, [department => department.department.toLowerCase()], ['asc'])
			componentFiltersData.costCentersList.sort(function (a, b) {
				return a.toLowerCase().localeCompare(b.toLowerCase());
			});
			componentFiltersData.jobFunctionsList.filter(jobFunction => jobFunction != null).sort(function (a, b) {
				return a.toLowerCase().localeCompare(b.toLowerCase());
			});

			setFiltersData({ ...filtersData, [componentName]: componentFiltersData })

			componentFilters['dataFilters'].country = value
			componentFilters['dataFilters'].department = componentFiltersData.departmentsList.map(obj => {
				return obj.department
			})
			componentFilters['dataFilters'].function = componentFiltersData.jobFunctionsList
			componentFilters['dataFilters'].costCenter = componentFiltersData.costCentersList

		} else {
			let componentFiltersData = { ...filtersData[componentName] }

			componentFiltersData.departmentsList = []
			componentFiltersData.jobFunctionsList = []
			componentFiltersData.costCentersList = []

			setFiltersData({ ...filtersData, [componentName]: componentFiltersData })

			componentFilters = filter
		}
		setReportFilters({ ...reportFilters, [componentName]: componentFilters })
	}

	useEffect(() => {
		axios(`/api/forecast`)
			.then((result) => {
				const formatedForecastOptions = result.data.data.map((d) => {
					return { 'value': d.id, 'label': d.name }
				})
				setForecastOptions(formatedForecastOptions)
			})
			.catch((error) => {
				console.log(error)
				setForecastOptions([])
			})
	}, [forecastsDataVersion])

	const hiringForecastCreated = () => {
		setForecastsDataVersion(forecastsDataVersion + 1)
	}

	const forecastSelectionChanged = (componentName, selectedForecast) => {
		setSelectedForecasts({
			...selectedForecasts,
			[componentName]: selectedForecast,
		})
	}

	const onCurrencySelect = (value) => {
		let currentSelectedValue = ''
		availableCurrencies.forEach((currency) => {
			if (currency.short_code === value) {
				currentSelectedValue = currency
			}
		})
		setSelectedCurrency(currentSelectedValue)
		localStorage.setItem('selectedCurrency', JSON.stringify(currentSelectedValue))
	}

	useEffect(() => {
		document.title = `CompKit - Reports`;
	})

	return (
		<>
			<div className={classes.reportsNavbarContainer}>
				<ButtonGroup color="primary">
					<Button
						className={
							reportType === 'workforce'
								? classes.selectedReport
								: ''
						}
						onClick={() => changeReport('workforce')}
					>
						WorkForce
                    </Button>
					{showOnlyWorkForce ? null : <Button
						className={
							reportType === 'compensation'
								? classes.selectedReport
								: ''
						}
						onClick={() => changeReport('compensation')}
					>
						Compensation
                    </Button>}
					{showOnlyWorkForce ? null : <Button
						className={
							reportType === 'orgnaziation'
								? classes.selectedReport
								: ''
						}
						onClick={() => changeReport('orgnaziation')}
					>
						Organization
                    </Button>}
				</ButtonGroup>
				<FormControl className={classes.dataFieldformControl}>
					<InputLabel htmlFor="select-multiple-checkbox">Currencies</InputLabel>
					<Select
						value={selectedCurrency !== null ? selectedCurrency.short_code : 'USD'}
						onChange={(e) => onCurrencySelect(e.target.value)}
					>
						{availableCurrencies.map((currency, index) => (
							<MenuItem key={currency.short_code} value={currency.short_code}>
								<ListItemText primary={currency.full_name} />
							</MenuItem>
						))}
					</Select>
				</FormControl>
			</div>
			<Divider />
			{masterData && availableColumns ? (
				<Grid item xs={12}>
					{reportType === 'workforce' && (
						<WorkforceReport
							reportDataChanged={props.reportDataChanged}
							masterData={masterData}
							onDataFilterSelect={onDataFilterSelect}
							reportFilters={reportFilters}
							reportData={reportData}
							onApply={onApply}
							resetFilter={resetFilter}
							hiringForecastCreated={hiringForecastCreated}
							forecastOptions={forecastOptions}
							selectedForecasts={selectedForecasts}
							forecastSelectionChanged={forecastSelectionChanged}
							availableColumns={availableColumns}
							fetchedFilterData={fetchedFilterData}
							filtersData={filtersData}
							reportFiltersType={reportFiltersType}
						/>
					)}
					{reportType === 'compensation' && (
						<CashCompensation
							reportDataChanged={props.reportDataChanged}
							masterData={masterData}
							onDataFilterSelect={onDataFilterSelect}
							reportFilters={reportFilters}
							reportData={reportData}
							onApply={onApply}
							resetFilter={resetFilter}
							departmentReportVersion={departmentReportVersion}
							availableColumns={availableColumns}
							fetchedFilterData={fetchedFilterData}
							filtersData={filtersData}
							reportFiltersType={reportFiltersType}
						/>
					)}
					{reportType === 'orgnaziation' && (
						<Organization
							reportDataChanged={props.reportDataChanged}
							masterData={masterData}
							onDataFilterSelect={onDataFilterSelect}
							reportFilters={reportFilters}
							reportData={reportData}
							onApply={onApply}
							resetFilter={resetFilter}
							forecastOptions={forecastOptions}
							selectedForecasts={selectedForecasts}
							forecastSelectionChanged={forecastSelectionChanged}
							availableColumns={availableColumns}
							selectedCurrency={selectedCurrency}
							fetchedFilterData={fetchedFilterData}
							filtersData={filtersData}
							reportFiltersType={reportFiltersType}
						/>
					)}
				</Grid>
			) : null}
		</>
	)
}
